import { defineStore } from "pinia";

export const useColorStore = defineStore('colorStore', {
    state: () => ({
        isLightTheme: false,
    }),
    getters: {
        getTheme: (state) => state.isLightTheme ? 'light' : 'dark',
    },
    actions: {
        toggleTheme() {
            this.isLightTheme = !this.isLightTheme;
            document.documentElement.setAttribute('data-theme', this.isLightTheme ? 'light' : 'dark');
        },
        setLightTheme() {
            this.isLightTheme = true;
            document.documentElement.setAttribute('data-theme', 'light');
        },
        setDarkTheme() {
            this.isLightTheme = false;
            document.documentElement.setAttribute('data-theme', 'dark');
        },
    },
    persist: true,
});

export const useLocaleStore = defineStore('localeStore', {
    state: () => ({
        currentLocale: 'fr' as 'fr' | 'en',
    }),
    getters: {
        locale: (state) => state.currentLocale,
        isFrench: (state) => state.currentLocale === 'fr',
    },
    actions: {
        toggleLocale() {
            this.currentLocale = this.currentLocale === 'fr' ? 'en' : 'fr';
        },
        setLocale(locale: 'fr' | 'en') {
            this.currentLocale = locale;
        },
        setFrench() {
            this.currentLocale = 'fr';
        },
        setEnglish() {
            this.currentLocale = 'en';
        }
    },
    persist: true,
});
